export default "__VITE_ASSET__Bkip3DoX__"